<app-state-view class="results-listing" [state]="state">
  <loading-state>
    <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
  </loading-state>
  <empty-state>
    <div class="results-listing__placeholder">
      <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
      <div class="results-listing__placeholder-message">Please enter a search query to perform a search.</div>
    </div>
  </empty-state>
  <error-state>
    <div class="results-listing__placeholder results-listing__placeholder--error">
      <mat-icon class="results-listing__placeholder-icon">warning</mat-icon>
      <div class="results-listing__placeholder-message">
        {{ errorMessage || 'An error occurred performing the search. Please try again later.' }}
      </div>
    </div>
  </error-state>
  <content-state>
    <div class="results-listing__container">
      <div class="results-listing__filter-bar">
        <button #serviceRepairPopoverAnchor="satPopoverAnchor" type="button" class="results-listing__filter"
                [satPopoverAnchorFor]="serviceRepairFiltersPopover" (click)="serviceRepairFiltersPopover.toggle()"
                [class.results-listing__filter--active]="serviceRepairPopoverAnchor.isPopoverOpen()">
          Service/Repair Filters
          <mat-icon class="results-listing__filter-arrow">keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <div #serviceRepairListEl *ngIf="serviceRepairs && serviceRepairs.length > 0; else placeholder" class="results-listing__list">
        <a class="service-repair-card"
           #serviceRepairEl *ngFor="let serviceRepair of serviceRepairs"
           [class.service-repair-card--active]="serviceRepair === activeServiceRepair"
           [routerLink]="['/business', serviceRepair.businessId]"
           (click)="onServiceRepairSelected()"
           (mouseenter)="onServiceRepairHover(serviceRepair, true)"
           (mouseleave)="onServiceRepairHover(serviceRepair, false)">
          <div class="service-repair-card__type-row">
            <span class="service-repair-card__type">{{ serviceRepair.categories && serviceRepair.categories.length ? serviceRepair.categories.join(' · ') : 'Service/Repair' }}</span>
          </div>
          <div class="service-repair-card__main">
            <div class="service-repair-card__content">
              <h2 class="service-repair-card__name">{{ serviceRepair.name }}</h2>
              <div class="service-repair-card__body">
                <div class="service-repair-card__text" *ngIf="serviceRepair.airportName || serviceRepair.airportIdent">
                  <ng-container *ngIf="serviceRepair.airportName">{{ serviceRepair.airportName }}</ng-container><ng-container *ngIf="serviceRepair.airportName && serviceRepair.airportIdent"> - </ng-container><ng-container *ngIf="serviceRepair.airportIdent">({{ serviceRepair.airportIdent }})</ng-container>
                </div>
                <div class="service-repair-card__text" *ngIf="serviceRepair.city || serviceRepair.stateProvince">
                  {{ serviceRepair.city }}<ng-container *ngIf="serviceRepair.city && serviceRepair.stateProvince">, </ng-container>{{ serviceRepair.stateProvince }}
                </div>
              </div>
            </div>
            <div class="service-repair-card__photo" *ngIf="serviceRepair.thumbnailPhotoPath">
              <img class="service-repair-card__image" [src]="serviceRepair.thumbnailPhotoPath" alt="" />
            </div>
          </div>
        </a>
      </div>
      <mat-paginator
        *ngIf="serviceRepairs && serviceRepairs.length > 0"
        class="results-listing__pagination"
        [pageIndex]="pageIndex"
        [length]="totalServiceRepairs"
        [pageSize]="pageSize"
        (page)="onPageChanged($event)">
      </mat-paginator>
    </div>
  </content-state>
</app-state-view>

<ng-template #placeholder>
  <div class="results-listing__placeholder">
    <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
    <div class="results-listing__placeholder-message">
      No results found matching your search criteria. Try reducing the number of filters used in the search.
    </div>
  </div>
</ng-template>


<sat-popover #serviceRepairFiltersPopover horizontalAlign="start" verticalAlign="below" hasBackdrop>
  <div class="results-listing__popover">
    <app-service-repair-finder-filter-list #serviceRepairFilters [query]="query" [compact]="true"
                                (filtersChange)="onFiltersChanged()">
    </app-service-repair-finder-filter-list>
  </div>
</sat-popover>
